import { render } from "./OperatingSystemsSubComponent.vue?vue&type=template&id=1cf88b9a"
import script from "./OperatingSystemsSubComponent.vue?vue&type=script&lang=js"
export * from "./OperatingSystemsSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__